import type { Ref } from 'vue';
import { useModal } from 'vue-final-modal';
import { onBeforeRouteLeave, useRouter } from 'vue-router';
import { ConfirmCloseModal } from '@/shared/ui';

export interface UnsavedChangesGuardOptions {
  isDirty: Ref<boolean>;
  title: string;
  description: string;
  /** Runs before the navigation resumes, so the caller can drop its snapshot and stay out of the guard. */
  onDiscard?: () => void;
}

export function useUnsavedChangesGuard(options: UnsavedChangesGuardOptions): void {
  const router = useRouter();

  onBeforeRouteLeave((to, _from, next) => {
    if (!options.isDirty.value) {
      next();
      return;
    }

    const { open, close } = useModal({
      component: ConfirmCloseModal,
      attrs: {
        title: options.title,
        description: options.description,
        onClose() {
          close();
        },
        onConfirm() {
          close();
          options.onDiscard?.();
          router.push(to);
        },
      },
    });
    open();
    next(false);
  });
}
